import { useDispatch, useSelector } from "react-redux";
import { setInfo as setUserInfo } from "../redux/user";

const getInfo = state => state.user.info;

const useUserInfo = () => {
  const dispatch = useDispatch();
  const info = useSelector( getInfo );
  const setInfo = data => { dispatch( setUserInfo( data ) ) };

  return {
    info,
    setInfo
  };

};

export default useUserInfo;
